import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Modal from '../../../../components/Modal';
import message from '../../../../constant/message';
import LenderUgroService from '../../../../services/lender';

const FundOutModal = ({ userType, state, toggleModal, leadId, reloadTable, rowData, selectedLender, editMode, lafNumber, companyData, isBtCase }) => {
    const [loading, setLoading] = useState(false);
    const [utr, setUTR] = useState('');
    const [fundamount, setfundamount] = useState('');
    const [fundoutDate, SetfundoutDate] = useState('');
    const [accountno, Setaccountno] = useState('');
    const [lenderID, setLenderID] = useState(selectedLender)
    // const [file, setFile] = useState(null);
    const [errors, setErrors] = useState();
    const [LANno, setLANno] = useState('');
    const [customerName, setCustomerName] = useState(companyData?.company_name || '');
    const [branchName, setBranchName] = useState('');
    const [utrDate, setUtrDate] = useState('');
    const [amountSplit, setAmountSplit] = useState(80);
    const [disbursalType, setDisbursalType] = useState(3);
    
    useEffect(() => {
        setUTR(rowData?.utr_no)
        setfundamount(rowData?.netpay_amount)
        Setaccountno(rowData?.account_no)
        SetfundoutDate(rowData?.payout_date?.split(' ')[0])
        setLANno(rowData?.lan_no)
        setUtrDate(rowData?.utr_date)
        setCustomerName(companyData?.company_name || rowData?.cust_name)
        setBranchName(rowData?.branch_name)
        setAmountSplit(rowData?.amount_split || 80)
        setLenderID(rowData?.lender_id)
        setDisbursalType(rowData?.disbursal_type || 3)
    }, []);
    
    const formSubmitHandler = async (e) => {
        e.preventDefault();
        setLoading(true);
        const formData = new FormData();
        if (editMode) {
            LANno && formData.append('lan_no', LANno);
            utr && formData.append('utr_no', utr);
            fundamount && formData.append('netpay_amount', fundamount);
            accountno && formData.append('account_no', accountno);
            customerName && formData.append('cust_name', customerName);
            branchName && formData.append('branch_name', branchName);
            fundoutDate && formData.append('payout_date', fundoutDate);
            utrDate && formData.append('utr_date', utrDate);
            amountSplit && formData.append('amount_split', amountSplit);
            leadId && formData.append('lead_id', leadId);
            lenderID && formData.append('lender_id', lenderID);
            rowData?.lead_fundout_id && formData.append('lead_fundout_id', rowData?.lead_fundout_id);
            disbursalType && formData.append('disbursal_type', disbursalType);
        } else {
            LANno && formData.append('lan_no', LANno);
            utr && formData.append('utr_no', utr);
            fundamount && formData.append('netpay_amount', fundamount);
            accountno && formData.append('account_no', accountno);
            customerName && formData.append('cust_name', customerName);
            branchName && formData.append('branch_name', branchName);
            fundoutDate && formData.append('payout_date', fundoutDate);
            utrDate && formData.append('utr_date', utrDate);
            amountSplit && formData.append('amount_split', amountSplit);
            leadId && formData.append('lead_id', leadId);
            selectedLender && formData.append('lender_id', selectedLender);
            disbursalType && formData.append('disbursal_type', disbursalType);
        }
        // file && formData.append('file', file);
        try {
            let apiResponse;
            apiResponse = await LenderUgroService.addFundout({
                type: userType,
                formData,
                subType: userType === 'admin' ? 'co-lender' : '',
            });
            if (apiResponse?.data?.status?.code === 1) {
                toast.success(
                    apiResponse?.data?.data?.messages?.[0]?.[0] || message.SAVED_SUCCESS
                );
                toggleModal();
                reloadTable();
            }
        } catch (err) {
            setLoading(false);
            let error = err?.response?.data?.messages?.error;
            toast.error(error?.form?.[0] || error?.others?.[0]);
            setErrors(error?.fields);
        }
    };

    return (
        <Modal state={state} closeModal={toggleModal} style={{ width: "450px" }} removeBorderSpace={true}>
            <div className="modal-header-container">
                <div className="modal-title">UTR Details (<span style={{ color: "#4A4E88", fontSize: '12px' }}>LAF : {`${lafNumber}`}</span>)</div>
                <div className="closeModalView" onClick={toggleModal}>
                    <span className="closeModalIcon">x</span>
                </div>
            </div>
            <div className='p-4'>
                <form onSubmit={formSubmitHandler}>
                    <div style={{ height: "400px", overflowY: "scroll", overflowX: 'clip', padding: "2%" }}>
                        <div class='form-group'>
                            <label> Disbursal Type <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <select
                                        class='form-control custom-form-control'
                                        onChange={(e) => setDisbursalType(e.target.value)}
                                        value={disbursalType}
                                    >
                                        <option value={''}>Please Select</option>
                                        <option value={1}>Customer Disbursal for 100% Transfer</option>
                                        {isBtCase && <option value={6}>Bank Disbursal for 100% Transfer- Cheque</option>}
                                        {isBtCase && <option value={7}>Bank Disbursal for 100% Transfer- NEFT/RTGS</option>}
                                        {!isBtCase && <option value={2}>UGRO Share into ESCROW- Customer Transfer</option>}
                                        {isBtCase && <option value={4}>UGRO Share into ESCROW- BT Bank Transfer</option>}
                                        {isBtCase && <option value={5}>UGRO Share into ESCROW- BT Customer Transfer</option>}
                                        {!isBtCase && <option value={3}>Lender share into ESCROW</option>}
                                    </select>
                                </div>
                            </div>
                            <tt>
                                {errors && errors?.disbursal_type}
                            </tt>
                        </div>
                        <div class='form-group'>
                            <label> Amount Split % <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <select
                                        class='form-control custom-form-control'
                                        onChange={(e) => setAmountSplit(e.target.value)}
                                        value={amountSplit}
                                    >
                                        <option value={''}>Please Select</option>
                                        <option value={100}>100%</option>
                                        <option value={80}>80%</option>
                                        <option value={70}>70%</option>
                                        <option value={30}>30%</option>
                                        <option value={20}>20%</option>
                                    </select>
                                </div>
                            </div>
                            <tt>
                                {errors && errors?.amount_split}
                            </tt>
                        </div>
                        {/* <div class='form-group'>
                            <label>UGRO Branch Name <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <input
                                        class='form-control custom-form-control'
                                        value={branchName}
                                        onChange={(e) => setBranchName(e.target.value)}
                                        maxlength="50"
                                    />
                                </div>
                            </div>
                            <tt>
                                {errors && errors?.branch_name}
                            </tt>
                        </div> */}
                        {/* <div class='form-group'>
                            <label>LAN Number </label>
                            <div class='row'>
                                <div class='col-12'>
                                    <input
                                        class='form-control custom-form-control'
                                        value={LANno}
                                        onChange={(e) => setLANno(e.target.value)}
                                        maxlength="25"
                                    />
                                </div>
                            </div>
                        </div> */}
                        <div class='form-group'>
                            <label>Cheque / UTR Number <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <input
                                        class='form-control custom-form-control'
                                        value={utr}
                                        onChange={(e) => setUTR(e.target.value)}
                                        maxlength="25"
                                    />
                                </div>
                            </div>
                            <tt>
                                {errors && errors?.utr_no}
                            </tt>
                        </div>
                        <div class='form-group'>
                            <label>Payment Amount <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <input
                                        class='form-control custom-form-control'
                                        type='text'
                                        value={fundamount}
                                        onChange={(e) => setfundamount(e.target.value.replace(/[^0-9.]/g, ''))}
                                        maxlength="15"
                                    />
                                </div>
                            </div>
                            <tt>
                                {errors && errors?.netpay_amount}
                            </tt>
                        </div>
                        {/* <div class='form-group'>
                            <label>Account Number <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <input
                                        class='form-control custom-form-control'
                                        type='text'
                                        value={accountno}
                                        onChange={(e) => Setaccountno(e.target.value.replace(/[^0-9]/g, ''))}
                                        maxlength="25"
                                    />
                                </div>
                            </div>
                            <tt>
                                {errors && errors?.account_no}
                            </tt>
                        </div> */}
                        <div class='form-group'>
                            <label>Customer Name <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <input
                                        class='form-control custom-form-control'
                                        value={customerName}
                                        onChange={(e) => setCustomerName(e.target.value)}
                                        maxlength={50}
                                    />
                                </div>
                            </div>
                            <tt>
                                {errors && errors?.cust_name}
                            </tt>
                        </div>
                        {/* <div class='form-group'>
                            <label> UTR Date <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <input
                                        type='Date'
                                        className='form-control'
                                        name='date'
                                        value={utrDate}
                                        onChange={(e) => setUtrDate(e.target.value)}
                                        max={new Date().toISOString().split('T')[0]}
                                    />
                                </div>
                            </div>
                            <tt>
                                {errors && errors?.utr_date}
                            </tt>
                        </div> */}
                        <div class='form-group'>
                            <label> Payment Date <tt>*</tt></label>
                            <div class='row'>
                                <div class='col-12'>
                                    <input
                                        type='Date'
                                        className='form-control'
                                        name='date'
                                        value={fundoutDate}
                                        onChange={(e) => SetfundoutDate(e.target.value)}
                                        max={new Date().toISOString().split('T')[0]}
                                    />
                                </div>
                            </div>
                            <tt>
                                {errors && errors?.payout_date}
                            </tt>
                        </div>
                    </div>
                    {/* {userType !== 'lender' && (
					<div class='form-group'>
						<label>Document Upload</label>
						<div class='row'>
							<div class='col-12'>
								<input
									type='file'
									className='form-control'
									name='date'
									onChange={(e) => setFile(e.target.files[0])}
								/>
							</div>
							{errors && (
								<p className='mt-2 mb-0 text-danger'>{errors.fields.file[0]}</p>
							)}
						</div>
					</div>
				)} */}
                    <div class='d-flex align-items-center justify-content-center mt-3'>
                        <button type='submit' class='btn btn-custom' disabled={loading}>
                            {loading ? <div className='loader' /> : 'OK'}
                        </button>
                        <button
                            type='button'
                            class='btn btn-outline-custom ml-2'
                            data-dismiss='modal'
                            onClick={toggleModal}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default FundOutModal;
